import React, {useEffect, useState} from 'react';
import Header from './Components/Header';
import './Assets/scss/CV.scss'
import Jobs from './Components/Jobs';
import Education from './Components/Education';
import SideProjects from './Components/SideProjects';
import Languages from './Components/Languages';
import Interests from './Components/Interests';
import Skills from './Components/Skills';
import {Me} from './Model/me';

function CV() {

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [cv, setCV] = useState<Me>(new Me());

    useEffect(() => {
        fetch(/*process.env.REACT_APP_API_BASE_URL + */"https://amine-bouabdallaoui.fr/api/me")
            .then(res => res.json())
            .then(
                (result: Me) => {
                    setIsLoaded(true);
                    setCV(result);
                    document.title = result.profile.name;
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }, [])

    if (error) {
        return <div>Error: {error}</div>;
    } else if (!isLoaded) {
        return <div>Loading...</div>;
    } else {

        return (<div className="CV">
                <Header tags={cv.tags.filter(t => t.workThing)} profile={cv.profile}/>
                <div className="card flex divide-x divide-gray-600">
                    <div className="basis-3/4 pr-2 divide-y divide-gray-400 details">
                        <Jobs jobs={cv.jobs}/>
                        <Education education={cv.educationYears}/>
                        <SideProjects projs={cv.sideProjects}/>
                    </div>
                    <div className="basis-1/4 pl-2  divide-y divide-gray-400 details">
                        <Skills tags={cv.tags}/>
                        <Languages langs={cv.languages}/>
                        <Interests interests={cv.interests}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default CV;
